export default __webpack_public_path__ + "static/media/bell_btn.0968bc13.png";